import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import { Redirect } from 'react-router-dom';
import { PATH_PAGE } from 'src/routes/paths';
import LoadingScreen from 'src/components/LoadingScreen';

// ----------------------------------------------------------------------

AuthProtectPurchaseOrderBuyerAdd.propTypes = {
  children: PropTypes.node
};

const home_url = process.env.REACT_APP_DOMAIN;

/**
 * 16072026
 * SINCE FROM CLOSED OFFERS BUYER, CLOSED OFFERS MODULE, PURCHASE ORDER BUYER MODULE CAN CREATE STANDALONE PURCHASE ORDER
 * ACCESS WILL INCLUDE FROM THESE 3 MODULES
 * @returns 
 */
function AuthProtectPurchaseOrderBuyerAdd({ children }) {
  const { isLoading, isAuthenticated, user } = useAuth();

  let subAccessList = user.access_list

  console.log('AuthProtect')
  console.log(user)
  
  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated || (!subAccessList.includes('purchaseOrderBuyerAdd') && !subAccessList.includes('closedOffersBuyerAddPurchaseOrder') && !subAccessList.includes('closedOffersBuyerManagerAddPurchaseOrder'))) {
    window.location = `${home_url}/unauthorized`
    return <LoadingScreen />
  }

  return <>{children}</>;
}

export default AuthProtectPurchaseOrderBuyerAdd